import { DirectSpendLimitType } from '../data-layer/direct/types';

export const disableContentPromotionGoalsCost = (spendLimitType?: DirectSpendLimitType) =>
    spendLimitType === DirectSpendLimitType.WEEKLY_LIMIT ||
    spendLimitType === DirectSpendLimitType.CRR;
